module.exports = __webpack_public_path__ + "media/pristine-609.ea1aaabc.ogg";